import { authorizedFetch } from "./base";
import type { AppleCredential } from "./auth";

export async function setPassword(
  newPassword: string,
  currentPassword?: string,
): Promise<void> {
  await authorizedFetch<void>("/users/me/password", {
    method: "POST",
    body: JSON.stringify({
      new_password: newPassword,
      current_password: currentPassword,
    }),
  });
}

export async function unlinkGoogle(): Promise<void> {
  await authorizedFetch<void>("/users/me/google/unlink", { method: "POST" });
}

export async function linkGoogle(idToken: string): Promise<void> {
  await authorizedFetch<void>("/users/me/google/link", {
    method: "POST",
    body: JSON.stringify({ id_token: idToken }),
  });
}

export async function unlinkApple(): Promise<void> {
  await authorizedFetch<void>("/users/me/apple/unlink", { method: "POST" });
}

export async function linkApple(credential: AppleCredential): Promise<void> {
  await authorizedFetch<void>("/users/me/apple/link", {
    method: "POST",
    body: JSON.stringify({
      identity_token: credential.identityToken,
      authorization_code: credential.authorizationCode,
      nonce: credential.nonce,
    }),
  });
}
